<template>
    <div class="sms-wrapper">
        <a-modal
            class="sms-history"
            :visible="visible"
            :title="$t('program.send_sms_history'/*短信发送记录*/ )"
            :width="1100"
            :maskClosable="false"
            :confirm-loading="loading"
            @cancel="handleCancel"
            :footer="null">
            <!--    搜索条件    -->
            <div class="table-page-search-wrapper mt30" ref="myHeader">
                <a-form layout="inline" class="hidden">
                    <a-row :gutter="[10, 10]">
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-input v-model="searchParams.phone" :placeholder="$t('form.phone')/* 手机号 */"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-input v-model="searchParams.real_name" :placeholder="$t('form.compellation')/* 姓名 */"></a-input>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-button type="primary" @click="handleSearch" style="">{{ $t('web.search' /* 搜索 */) }}</a-button>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table ref="table" size="default" :rowKey="record => record.order_id" :columns="columns" :dataSource="dataList" :pagination="false" class="mt20">
                <template slot="status" slot-scope="text">
                    <a-badge v-if="text == 1" status="success" :text="$t('program.send_success')/* 发送成功 */" />
                    <a-badge v-if="text == 0" status="processing" :text="$t('program.not_sent')/* 未发送 */"></a-badge>
                    <a-badge v-if="text == 2" status="error" :text="$t('program.send_failed')/* 发送失败 */" />
                </template>
            </a-table>
            <div class="t-r mt30">
                <a-pagination
                    :show-total="total => $t('web.pagination_total', { value: total } /* 共{value}条 */)"
                    show-size-changer
                    v-model="pagination.page"
                    :page-size="pagination.limit"
                    :total="paginationTotal"
                    @change="handlePaginationChangeEvent"
                    @showSizeChange="handlePaginationChangeEvent"
                />
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    name: 'subscribeModal',
    props: {
    },
    data() {
        return {
            visible: false,
            loading: false,
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    align: 'center',
                    fixed: 'left',
                    width: 50
                },
                {
                    title: this.$t('program.message_type')/* 消息类型 */,
                    dataIndex: 'title',
                    align: 'center',
                    width: 120
                },
                {
                    title: this.$t('program.send_content')/* 发送内容 */,
                    dataIndex: 'content',
                    align: 'center',
                    width: 130
                },
                {
                    title: this.$t('program.message_create_time')/* 消息创建时间 */,
                    dataIndex: 'create_time',
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('program.receiver')/* 接收人 */,
                    dataIndex: 'send_real_name',
                    align: 'center',
                    width: 100
                },

                {
                    title: this.$t('program.receiver_phone')/* 接收人手机号 */,
                    dataIndex: 'target',
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('program.send_status')/* 发送状态 */,
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('program.send_time')/* 发送时间 */,
                    dataIndex: 'send_time',
                    align: 'center',
                    width: 100
                }
            ],
            searchParams: {
            },
             // 分页
            pagination: {
                page: 1,
                limit: 10
            },
            dataList: [],
            paginationTotal: 0,
        };
    },
    created () {
    },
    methods: {
        /**
         * 打开短信发送记录
         * @param type 类型 1 Session短信发送记录 2 主持人短信发送记录 3 日程订阅短信发送记录
        */
        showFun(type) {
            this.searchParams.type = type
            this.visible = true
            this.getDataList()
        },
        getDataList () {
            let data = {
                ...this.searchParams,
                ...this.pagination
            }
            this.loading = true
            this.$request.get({ url: 'getSmsHistoryList', data }).then((res) => {
                const { count, list } = res.data
                this.dataList = list
                this.paginationTotal = Number(count)
            }).finally(() => {
                this.loading = false
            })
        },
        handleCancel() {
            this.visible = false;
        },
        handleSearch () {
            this.getDataList()
        },
        // 切换分页
        handlePaginationChangeEvent(page, limit) {
            this.pagination = {
                page,
                limit
            };
            this.getDataList();
        }
    },
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
/deep/ .table-page-search-wrapper .ant-form-inline .ant-form-item {
    margin-bottom: 0px;
}
</style>